import { CopyAllOutlined } from "@mui/icons-material";
import { DialogTitle, IconButton } from "@mui/material";
import Utils from "../libs/Utils";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";

export default function ShareDlg(props:{url:string}){
    const {setSnackbar} = useSnackbar()
    const onCopy = () => {
        Utils.clipboard(props.url)
        setSnackbar(null, "URL is copied", "info")
    }
    return <>
        <DialogTitle>File share</DialogTitle>
        <div className="content mt-16">
            <div className="url flex middle between gap-24">
                <div className="text flex1">{props.url}</div>
                <IconButton size="small" onClick={onCopy}><CopyAllOutlined/></IconButton>
            </div>
        </div>
    </>
}